import { createStyles } from '@material-ui/core';

import Colours from 'bz-core-controls/styles/colours';

export const styles = createStyles({
  active: {},
  disabled: {},
  tab: {
    background: Colours.blueGrey400,
    padding: '4px 8px',
    marginRight: 4,
    color: Colours.white,
    fontFamily: 'Montserrat',
    cursor: 'pointer',
    minWidth: 80,
    flex: '0 1 auto',
    '&:hover': {
      background: Colours.blueGrey600
    },
    '&.active': {
      background: Colours.blueGrey700
    },
    '&$active': {
      background: Colours.blueGrey700
    },
    '&.disabled': {
      background: Colours.grey300,
      color: Colours.grey100,
      pointerEvents: 'none'
    },
    '&$disabled': {
      background: Colours.grey300,
      color: Colours.grey100,
      pointerEvents: 'none'
    }
  }
});

export default styles;
